import React, { useRef, useState } from 'react';

import styled from 'styled-components';

import { FormField, TextField } from 'components';
import { CloseCircle } from 'iconsax-react';

import { dayjs, useForm } from 'third-party';

import { DISPLAY_DATE_FORMAT } from 'constants/common';

import { FormFieldProps } from 'components/FormField/FormField';
import { DesktopDatePicker } from 'components/index';

const StyledDatepicker = styled(DesktopDatePicker)`
  width: 100%;
`;

const popperDateSx = {
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    fontWeight: 700,
    color: '#0F172A',
  },
  '& .MuiPickersYear-yearButton': {
    fontSize: '0.875rem',
    margin: '0.4rem 0',
    '&.Mui-selected': {
      color: '#ffffff',
    },
  },
  '& .MuiPickersDay-root, & .MuiPickersDay-dayWithMargin': {
    fontSize: '0.875rem',
    color: '#5C6C80',
    '&[aria-selected="true"]': {
      color: '#ffffff',
    },
    '&.MuiPickersDay-today, &[aria-current="date"]': {
      borderColor: '#007170',
      backgroundColor: '#007170',
      color: '#ffffff',
    },
  },
};

type DateFieldProps = FormFieldProps;

export const FormDateField: React.FC<DateFieldProps> = ({ ...props }) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const fieldRef = useRef<any>(null);

  const {
    formState: { errors },
  } = useForm();

  return (
    <FormField
      render={({ field }) => {
        fieldRef.current = field;

        return (
          <StyledDatepicker
            open={datePickerOpen}
            onOpen={() => setDatePickerOpen(true)}
            onClose={() => setDatePickerOpen(false)}
            format={DISPLAY_DATE_FORMAT}
            value={field.value ? dayjs(field.value) : null}
            disabled={props.isDisabled}
            onChange={(value: any, ...args: any[]) => {
              field.onChange(value, ...args);
            }}
            slots={{
              textField: TextField,
              clearIcon: () => <CloseCircle variant="TwoTone" size="1rem" />,
            }}
            slotProps={{
              popper: {
                sx: popperDateSx,
                placement: 'bottom-start',
              },
              field: {
                clearable: true,
                onClear: () => field.onChange(null),
              },
              textField: {
                size: 'small',
                variant: 'outlined',
                disabled: props.isDisabled,
                error: !!errors[props.fieldName] && props.showError,
                onClick: () => setDatePickerOpen(true),
              } as any,
            }}
          />
        );
      }}
      {...props}
    />
  );
};
